import React from 'react';
import Title from '../texts/Title';
import Description from '../texts/Description';
import CustomButton from '../buttons/CustomButton';
import Social from '../social/Social';
import { MasterInfoElement } from './MasterInfoElement';
import withStylableSupport from './withStylableSupport';
var TitleWithStylableSupport = withStylableSupport(Title, 'info-element-title');
var DescriptionWithStylableSupport = withStylableSupport(Description, 'info-element-description');
var CustomButtonWithStylableSupport = withStylableSupport(CustomButton, 'info-element-custom-button-wrapper');
var SocialWithStylableSupport = withStylableSupport(Social, 'info-element-social');
var CompsMap = {
    Title: { pathInData: "titleParams", comp: TitleWithStylableSupport },
    CustomButton: { pathInData: "customButtonParams", comp: CustomButtonWithStylableSupport },
    Description: { pathInData: "descriptionParams", comp: DescriptionWithStylableSupport },
    Social: { pathInData: "socialParams", comp: SocialWithStylableSupport },
};
function renderWixInfoComponents(props, shouldControlHorizontalAlignment, shouldUseLineHeightFixer) {
    return (React.createElement(MasterInfoElement, { masterInfoConfig: props, CompsMap: CompsMap, shouldControlHorizontalAlignment: shouldControlHorizontalAlignment, shouldUseLineHeightFixer: shouldUseLineHeightFixer }));
}
export default renderWixInfoComponents;
//# sourceMappingURL=renderWixInfoComponents.js.map